module.exports = __webpack_public_path__ + "band_9_daughter.e59e1c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_9_daughter.png
// module id = wb4z
// module chunks = 0